module.exports = __webpack_public_path__ + "static/media/write_animated.d40914ad.gif";